import { useState, useEffect, useContext } from "react";
import { notify } from "../utils/utils";
import { AuthFetch } from "../services/api";
import { useModal } from './useModal';
import { useSpinner } from "./useSpinner";
import { UserContext } from "../context/provider/UserProvider";
// import { CalificacionesConductor } from "../app/pages/AtencionCliente/CalificacionConductores";

const estrellaOpcionDefault= {
    codEstrella: 0,
    descripcion: "",
    codUsuarioAccion: 0
}

const estrellaDefault = {
    cantidadEstrellas: 1,
    nomEstrella: "",
    codUsuarioAccion: 0
}

export const useCalificaciones = () => {

    const { stateUser} = useContext(UserContext);

    const [ calificaciones, setCalificaciones ] = useState(); // calificaciones Estrellas y opciones
    const [ calificacionesPromedio, setCalificacionesPromedio ] = useState(); // calificaciones promedio de los conductores
    const [ calificacionesDetalleConductor, setCalificacionesDetalleConductor ] = useState(); // calificaciones promedio de los conductores
    const [ estrellaOpcion, setEstrellaOpcion ] = useState(estrellaOpcionDefault);
    const [ estrella, setEstrella ] = useState(estrellaDefault);

    const [ spinner, mostrarSpinner, ocultarSpinner ] = useSpinner();
    const [ isOpenModal, openModal, closeModal] = useModal();

    
    useEffect(() => {
        // listarCalificaciones();
        // listarCalificacionPromedio()
    }, []);


    const listarCalificaciones = async () => {
        mostrarSpinner();
        try{
            const response = await AuthFetch('/Qualification/detailed')
            !response.isValid && notify(response.exceptions[0].description, 'error')
            setCalificaciones(response.isValid ? response.content : [])
            ocultarSpinner()

        }
        catch(error){
            ocultarSpinner()
            notify('Ocurrió un error en el servicio','error');
        }
    }

    const listarCalificacionPromedio = async () => { ///Listado de Calificaciones de los conductores (PROMEDIO)
        mostrarSpinner();
        const response = await AuthFetch('/Qualification/Drivers/average')
        if (response.isValid) {
            setCalificacionesPromedio(response.content)
        } else {
            notify(response.exceptions[0].description,"error")
        }
        ocultarSpinner()
    }

    const listarCalificacionesDetalleConductor = async (codConductor, codEmpresa) => { //Listado detallado de las calificaciones de los conductores
        const response = await AuthFetch(`/Qualification/Drivers/detailed?` + new URLSearchParams({
            codPersonaConductor: codConductor,
            codEmpresa: codEmpresa
        })) 
        if (response.isValid) {
            setCalificacionesDetalleConductor(response.content)
        } else {
            notify(response.exceptions[0].description,"error")
        }
    }

    const guardarEditarEstrella = async ()=>{
        if (estrellaOpcion.nomEstrella == ""){
            notify("Debe ingresar un nombre válido","error")
            return
        }
        const response = await AuthFetch('/Qualification', {
            method:'POST',
            body: JSON.stringify({
                cantidadEstrellas: estrella.cantidadEstrellas,
                nomEstrella: estrella.nomEstrella,
                uid: stateUser.uid 
            }),
        })
        notify(response.content, response.isValid ? 'success' : 'error');
        if(response.isValid == true){
            closeModal()
        }
    }

    const guardarEditarEstrellaOpcion = async () => {
        try{
            const response = await AuthFetch('/Qualification/detailed', {
                method:'POST',
                body: JSON.stringify({
                    codEstrella: estrellaOpcion.codEstrella,
                    descripcion: estrellaOpcion.descripcion,
                    uid: stateUser.uid 
                }),
            })
            notify(response.isValid ? response.content : response.exceptions[0].description, (response.isValid ? 'success' : 'error'));
            return response.isValid;
        }
        catch(e){
            notify('Ocurrió un error en el servicio')
            return false;
        }
    }

    const editarValorEstrellaOpcion = (key,value) =>{
        setEstrellaOpcion(estrellaOpcion => {
            return {
                ...estrellaOpcion,
                [key]: value
            }
        });
    }     

    const editarValorEstrella = (key,value) =>{
        setEstrella(estrella => {
            return {
                ...estrella,
                [key]: value
            }
        });
    }     
    

    return {
        listarCalificaciones,
        calificaciones,
        isOpenModal,
        closeModal,
        spinner,
        guardarEditarEstrellaOpcion,
        estrellaOpcion,
        editarValorEstrellaOpcion,
        listarCalificacionPromedio,
        calificacionesPromedio,
        calificacionesDetalleConductor,
        listarCalificacionesDetalleConductor,
        editarValorEstrella,
        guardarEditarEstrella,
        estrella
    };
}